import axios from "axios";
import jwtDecode from "jwt-decode";
import { history } from "./routes";

export const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.request.use(config => {
  if (localStorage.getItem("access_token")) {
    config.headers.Authorization = `Bearer ${localStorage.getItem(
      "access_token"
    )}`;
  }

  config.headers["Accept-Language"] =
    localStorage.getItem("stored_lang") || "pt-BR";

  return config;
});

export const getJwtData = () => {
  return jwtDecode(localStorage.getItem("access_token"));
};

api.interceptors.response.use(
  response => {
    // TODO: The API should be returning a proper response with the right status
    // code so we don't have to do this cleanup here
    if (response.data.code && ![200, 201].includes(response.data.code)) {
      if (response.data.code === 401) {
        localStorage.removeItem("access_token");
        history.push("/login");
      }

      // Replicate an actual axiosError. isAxiosError and toJSON have been left out
      // axiosError definition: https://github.com/axios/axios/blob/521444513969a08ec5ef943c41ba0812845ed4f9/lib/core/enhanceError.js#L23
      const error = new Error();
      error.config = response.config;
      error.code = response.code;
      error.request = response.request;
      error.response = response;
      throw error;
    }

    return response;
  },
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem("@BusCAR/dashboard-access");
      localStorage.removeItem("access_token");
      history.push("/login");
    }

    return Promise.reject(error);
  }
);

export const resetPasswordRequest = (token, password) =>
  api.post(
    "/users/reset_password",
    {
      password
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }
  );

export const forgotPasswordRequest = email =>
  api.post("/users/forgot_password", {
    email
  });

export const getEstimatedBudget = () =>
  api.get("/b3_criterios/estimated_budget_fixed_price");

export const checkout = (amount, config) => {
  if (!amount || isNaN(amount) || amount <= 0) {
    return false;
  }

  const { onSuccess, onClose, onError, encryption_key, postbackUrl } = config;

  const checkout = new window.PagarMeCheckout.Checkout({
    encryption_key,
    success: onSuccess,
    error: onError,
    close: onClose
  });

  // Obs.: é necessário passar os valores boolean como string
  checkout.open({
    amount,
    buttonText: "Pagar",
    buttonClass: "botao-pagamento",
    customerData: "true",
    createToken: "true",
    paymentMethods: "credit_card,boleto",
    postbackUrl,
    // customer: {
    //   external_id: '#123456789',
    //   name: 'Fulano',
    //   type: 'individual',
    //   country: 'br',
    //   email: 'fulano@email.com',
    //   documents: [
    //     {
    //       type: 'cpf',
    //       number: '71404665560',
    //     },
    //   ],
    //   phone_numbers: ['+5511999998888', '+5511888889999'],
    //   birthday: '1985-01-01'
    // },
    // billing: {
    //   name: 'Ciclano de Tal',
    //   address: {
    //     country: 'br',
    //     state: 'SP',
    //     city: 'São Paulo',
    //     neighborhood: 'Fulanos bairro',
    //     street: 'Rua dos fulanos',
    //     street_number: '123',
    //     zipcode: '05170060'
    //   }
    // },
    // shipping: {
    //   name: 'Ciclano de Tal',
    //   fee: 12345,
    //   delivery_date: '2017-12-25',
    //   expedited: true,
    //   address: {
    //     country: 'br',
    //     state: 'SP',
    //     city: 'São Paulo',
    //     neighborhood: 'Fulanos bairro',
    //     street: 'Rua dos fulanos',
    //     street_number: '123',
    //     zipcode: '05170060'
    //   }
    // },
    items: [
      {
        id: "1",
        title: "Creditos BusCAR",
        unit_price: 20000,
        quantity: 1,
        tangible: false
      }
      // ,
      // {
      //   id: 'a123',
      //   title: 'Caderno do Goku',
      //   unit_price: 3200,
      //   quantity: 3,
      //   tangible: true
      // }
    ]
  });
};

export const getCheckoutConfig = () => {
  return api.get("/b3_transacoes/get_pagarme_config");
};

export const completeCheckout = (url, transaction_token, amount) => {
  return api.post(url, {
    transaction_token,
    amount
  });
};

export const getBalance = () => api.get("/b3_transacoes/get_balance");

export const getHasBalance = budget =>
  api.get("/b3_transacoes/has_enough_balance", { params: { budget } });

export const getAnalysisHistory = (
  page,
  limit,
  { isEnterpriseEnv = false, conditions }
) => {
  const params = {
    page,
    limit
  };

  if (isEnterpriseEnv && conditions) {
    params["options"] = {
      conditions
    };
  }

  const url = isEnterpriseEnv
    ? `/b3_consultas/query_enterprise`
    : `/b3_consultas/query`;

  return api.get(url, { params });
};

export const getOperationById = id => {
  return api.get(`b3_propostas/get_by_id/${id}`);
};

export const getEmpreendimentos = filter =>
  api.get(`bacen_empreendimentos/get_all?filter=${filter}`);

export const getGlebaEmpreendimentos = glebaId =>
  api.get(`b3_proposta_gleba_empreendimentos/get_by_gleba_id/${glebaId}`);

export const deleteGlebaEmpreendimento = id =>
  api.post(`b3_proposta_gleba_empreendimentos/delete_relation`, {
    b3_proposta_gleba_empreendimento_id: id
  });

export const saveGlebaEmpreendimento = data =>
  api.post(`b3_proposta_gleba_empreendimentos/save_relation`, data);

export const getOperationsHistory = (page, limit, busca, orderBy) => {
  const params = {
    page,
    limit,
    busca,
    orderBy
  };

  return api.get("b3_propostas/query", { params });
};

export const getPlanEnterprise = () =>
  api.get("b3_consultas/get_plan_enterprise");

export const getResults = id => api.get(`/b3_consultas/get_results/${id}`);

export const getResultsMapLayers = restultId =>
  api.get(`/b3_consultas/get_results_map_layers/${restultId}`);

export const getAreaInfo = area_id =>
  api.get(`/b3_areas/search_aoi_info/${area_id}`);

export const processGlebasCarAoiFile = data =>
  api.post(`/b3_areas/search_glebas_aoi_file`, data);

export const accountConfirmationRequest = token =>
  api.get(`users/validate_email/${token}`);

export const userLogin = (email, password) => {
  return api.post("/users/login", { username: email, password });
};

export const processOperation = data => {
  return api.post("b3_propostas/save", data);
};

export const getOperation = id => {
  return api.get(`b3_lotes/get_operacao/${id}`);
};

export const getOperationCars = operationId => {
  return api.get(`b3_lotes/get_numero_cars_operacao/${operationId}`);
};

export const getOperationCarLinking = operationId => {
  return api.get(`b3_propostas/get_numero_cars_operacao/${operationId}`);
};

export const exportCoordinatesSicor = operationId => {
  return api.get(`b3_propostas/export_coordinates_sicor/${operationId}`);
};

export const processOperationKml = (operationId, data) => {
  return api.post(`b3_lotes/save_kml/${operationId}`, data);
};

export const processAoiFile = data => {
  return api.post(`b3_areas/search_aoi_file/`, data);
};

export const operationVinculaCar = data => {
  return api.post(`b3_propostas/save_car/`, data);
};

export const operationDesvinculaCar = data => {
  return api.post(`b3_propostas/delete_car/`, data);
};

export const operationGetCarLayers = (b3_proposta_id, layers) => {
  return api.get(
    `/b3_propostas/get_cars?b3_proposta_id=${b3_proposta_id}&layers=${layers}`
  );
};

export const operationGetResults = b3_proposta_id => {
  return api.get(
    `/b3_propostas/get_resultados?b3_proposta_id=${b3_proposta_id}`
  );
};

export const operationGetGlebas = b3PropostaId => {
  return api.get(`b3_propostas/get_glebas?b3_proposta_id=${b3PropostaId}`);
};

export const operationDeleteGleba = glebaId => {
  return api.post("b3_propostas/delete_gleba", {
    b3_proposta_gleba_id: glebaId
  });
};

export const operationSaveGleba = ({ b3PropostaId, geojson, trackId }) => {
  return api.post("b3_propostas/save_gleba", {
    b3_proposta_id: b3PropostaId,
    trackid: trackId,
    geojson
  });
};

export const operationSaveGlebaWithoutCar = ({ b3PropostaId, geojson }) => {
  return api.post("b3_propostas/save_gleba_sem_car", {
    b3_proposta_id: b3PropostaId,
    geojson
  });
};

export const operationSaveGlebaDescription = ({ b3PropostaId, glebaId, detalhes_json }) => {
  return api.post("b3_propostas/save_gleba_description", {
    b3_proposta_id: b3PropostaId,
    gleba_id: glebaId,
    detalhes_json: detalhes_json
  })
};

export const exportOperationKml = operationId => {
  return api.get(`b3_lotes/export_areas_operacao_kml/${operationId}`);
};

export const exportGlebaPropostaKml = operationId => {
  return api.post(`/b3_propostas/exporta_gleba_proposta_kml/`, {
    b3_proposta_id: operationId
  });
};

export const operationDownloadGleba = glebaId => {
  return api.post("b3_propostas/exporta_gleba_kml_id", {
    b3_proposta_gleba_id: glebaId
  });
};

export const exportGlebaConsultaKml = glebaIds => {
  return api.post(`/b3_propostas/exporta_gleba_kml/`, {
    b3_proposta_gleba_id: glebaIds
  });
};

export const generateSicarCaptcha = () => {
  return api.get("sicar_captchas/gera_captcha");
};

export const downloadCarAndAssignToOperation = data => {
  return api.post("b3_propostas/download_car_vincula_operacao", data);
};

export const linkCarToOperation = data => {
  return api.post("b3_propostas/vincula_car_proposta_sem_captcha", data);
};

export const getOperationFeatureCollection = operationId => {
  return api.get(`b3_lotes/get_feature_collection_operacao/${operationId}`);
};

export const exportOperationValidation = operationId => {
  return api.get(`b3_lotes/export_operacao_json/${operationId}`);
};

export const disableOperationReport = (reportId, operationId) => {
  return api.post("b3_lotes/disable_consulta_lote", {
    b3_lote_id: operationId,
    b3_consulta_id: reportId
  });
};

export const getCarLayersOperacao = operationId => {
  return api.get(`b3_lotes/get_car_layers_operacao/${operationId}`);
};

export const exportSicorCar = b3_proposta_car => {
  return api.get(`b3_propostas/export_sicor_car/${b3_proposta_car}`);
};

export const verifyFeaturePermission = requested_features => {
  return api.post("b3_propostas/verify_feature_permission", {
    requested_features
  });
};

export const processAnalysis = (consulta_id, { isEnterpriseEnv = false }) => {
  const url = isEnterpriseEnv
    ? `/b3_consultas/process_analysis_enterprise`
    : `/b3_consultas/process_analysis`;

  return api.post(url, { consulta_id });
};

export const generateResultPdf = (b3_consulta_id, criterios, b3_template_id) =>
  api.post("/b3_consultas/generate_pdf_criterias", {
    b3_consulta_id,
    criterios,
    b3_template_id
  });

export const generateResultPdfOperacao = b3_proposta_id =>
  api.post("/b3_propostas/generate_pdf_operacao", {
    b3_proposta_id
  });

export const exportOperacaoJson = operationId => {
  return api.get(`b3_propostas/export_operacao_json/${operationId}`);
};

export const getTemplates = () => api.get("/b3_templates/query");

export const checkAcceptanceOfTermsAndPolicies = () =>
  api.get("/documentos_lgpd/check_acceptance_terms");

export const saveAcceptanceOfTermsAndPolicies = (termsOfUse, privacyPolicy) =>
  api.post(
    `/documentos_lgpd/save_acceptance_terms?termo_id=${termsOfUse}&politica_id=${privacyPolicy}`
  );

export const getDashboardData = (minDate = null, maxDate = null) =>
  api.get(`/b3_estatisticas/data?min_date=${minDate}&max_date=${maxDate}`);

export const hasAccessToDashboard = () =>
  api.get("/b3_estatisticas/has_access");

export const exportCoordinates = area_id =>
  api.get(`/b3_areas/export_coordinates/${area_id}`);

export const generateImageLogo = () =>
  api.get(`/images/pj_logos`);

export const getUsersListing = (page, busca) => {
  return api.get(`/users/get_users_listing?page=${page}&limit=10${busca !== '' ? `&search=${busca}` : ''}`)
};